import { render, staticRenderFns } from "./ShopWalletTransactions.vue?vue&type=template&id=72bdb8f8&"
import script from "./ShopWalletTransactions.vue?vue&type=script&lang=ts&"
export * from "./ShopWalletTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports